export class FDemandeCreneaux {
    
  dateDebut:string;
  dateFin:string;
  idSite:number;
   

    constructor(dateDebut:string, dateFin:string, idSite:number){


      this.dateDebut = dateDebut;
      this.dateFin =dateFin;
      this.idSite = idSite;
        


   }

   private affecteDate(d:Date)
   {
    var dd = d.getDate();
    var mm = d.getMonth();
    var yyyy = d.getFullYear();
    var hh = d.getHours();
    var min = d.getMinutes();
    var se = d.getSeconds();
    return new Date(yyyy, mm, dd, hh, min, se, 0);
   }
   

  }